module.exports = __webpack_public_path__ + "static/media/info.67b03085.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/info.png
// module id = 413
// module chunks = 0